import React from 'react'

import './Card.scss'

export default ({ title = '', children }) => {
    return (
        <div className="card-layout">
            <div className="card">
                <h2 className="card__title">{title}</h2>
                <div className="card__content">{children}</div>
            </div>
        </div>
    )
}
